/** The persona's `device` decides which real browser profile the runner drives — all
 *  web apps, but on different platforms (see persona-agents/runner/deviceProfile.ts):
 *  iphone→iOS WebKit, android→Android Chromium, ipad→iPadOS WebKit, else desktop. */
export function deviceLabel(device?: string): string {
  const d = (device || '').toLowerCase();
  if (d.includes('android')) return 'Android · web';
  if (d.includes('iphone') || d.includes('phone')) return 'iOS · web';
  if (d.includes('ipad') || d.includes('tablet')) return 'iPadOS · web';
  return 'Desktop · web';
}
